import snakeGameImg from "./images/snakeGame.jpg";
import spotifyCloneImg from "./images/spotifyMusic.jpg";
import textutilsImg from "./images/textUtils.jpg";

const Projects = {
  snakeGame: {
    image: snakeGameImg,
    title: "Snake Game",
    technology: "HTML | CSS | JS",
    websiteLink: "https://vanilla-snakegame.netlify.app"
  },
  spotify: {
    image: spotifyCloneImg,
    title: "Spotify Music",
    technology: "HTML | CSS | JS",
    websiteLink: "https://vanilla-spotify.netlify.app"
  },    
  textutils: {
    image: textutilsImg,
    title: "Text Manupilator",
    technology: "HTML | CSS | JS | React JS",
    websiteLink: "https://react-textutils-website.netlify.app"
  },
};

export default Projects;
